import { gql } from "graphql-request";

export const READ_TENANT_BY_ID = gql`
  query ReadTenantByID($id: ID!) {
    readTenantByID(id: $id) {
      id
      companyID
      name
      status
      slug
      logoUrl
      primaryColor
      secondaryColor
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_ALL_TENANTS = gql`
  query ReadAllTenants {
    readAllTenants {
      id
      companyID
      name
      status
      slug
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_SELECTABLE_TENANTS = gql`
query ReadSelectableTenants {
  readAllSelectableTenants {
    id
    companyID
    name
    status
    slug
    createdAt
    updatedAt
    archivedAt
  }
}
`;

export const READ_TENANTS_BY_COMPANY_ID = gql`
  query ReadTenantsByCompanyID($companyID: ID!) {
    readTenantsByCompanyID(companyID: $companyID) {
      id
      companyID
      name
      status
      slug
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_TENANT_LOGIN_BRANDING_BY_SLUG = gql`
  query ReadTenantLoginBrandingBySlug($slug: String!) {
    readTenantLoginBrandingBySlug(slug: $slug) {
      tenantID
      name
      slug
      logoUrl
      primaryColor
      secondaryColor
    }
  }
`;
